<template>
    <div>
        <vuestic-widget headerText="Planos Práticos">
            <div class="row">
                <div class="col-md-12">
                    <form id="form_plano_pratico">
                        <div class="row justify-content-center">
                            <div class="col-md-6">
                                <InputIconGroup typeInput="text" idInput="constante" iconInput="fa-info" labelInput="Constante"></InputIconGroup>
                            </div>
                            <div class="col-md-6">
                                <InputIconGroup typeInput="text" idInput="titulo" iconInput="fa-info" labelInput="Título"></InputIconGroup>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button class="btn btn-secondary" id="btn_limpar" type="button">Limpar</button>&nbsp;&nbsp;
                                <button class="btn btn-primary" id="btn_salvar" type="button" @click="salvaInformacoes">Salvar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <br><br><br><br>
            <!--Botões da paginação-->
            <div class="row">
                <div class="col mx-auto">
                    <nav>
                        <ul class="pagination justify-content-center">
                            <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                                <a class="page-link" href="#" tabindex="-1">Anterior</a>
                            </li>
                            <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                                <a class="page-link" href="#" tabindex="-1">Anterior</a>
                            </li>                                      
                            <template v-for="(page, index) in table.pages">
                                <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                                    <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                                </li>
                                <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                                    <a class="page-link"  href="#" >{{ page }}</a>
                                </li>
                            </template>            
                            <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                                <a class="page-link" href="#" tabindex="-1">Próximo</a>
                            </li>
                            <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                                <a class="page-link" href="#" tabindex="-1">Próximo</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <!--Botões da paginação-->
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-responsive-sm">
                        <thead>
                            <tr>
                                <th v-for="th in tableOptions.thead" :key="th"  scope="col">{{th}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="table.load">
                                <td colspan="2" class="text-center">
                                    <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                                        <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                                            <component
                                                :animation-duration="1000"
                                                :is="'SpringSpinner'"
                                                :color="'#4AE387'"
                                                :size="80"
                                            >
                                            </component>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-show="!table.load" v-for="dados in table.data" class="tb-linha" :key="'plano_' + dados.id_plano_pratico">
                                <td>{{dados.constante}}</td>
                                <td>{{dados.titulo}}</td>
                            </tr>
                            <tr v-show="table.data.length === 0 && !table.load">
                                <td colspan="2" class="text-center">Nenhum registro encontrado.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!--Botões da paginação-->
            <div class="row">
                <div class="col mx-auto">
                    <nav>
                        <ul class="pagination justify-content-center">
                            <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                                <a class="page-link" href="#" tabindex="-1">Anterior</a>
                            </li>
                            <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                                <a class="page-link" href="#" tabindex="-1">Anterior</a>
                            </li>                                      
                            <template v-for="(page, index) in table.pages">
                                <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                                    <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                                </li>
                                <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                                    <a class="page-link"  href="#" >{{ page }}</a>
                                </li>
                            </template>            
                            <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                                <a class="page-link" href="#" tabindex="-1">Próximo</a>
                            </li>
                            <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                                <a class="page-link" href="#" tabindex="-1">Próximo</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <!--Botões da paginação-->
        </vuestic-widget>
    </div>
</template>

<script>
    import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
    import urlApi from '../../router/urlApi'
    import AgendamentoController from './AgendamentoController'
    import { Serialize } from '../../services/serializeFormData'
    import * as spinners from 'epic-spinners'
    window._ = require('lodash')

    export default {
        name: 'form-plano-teorico',
        components: {
            InputIconGroup,
            ...spinners
        },
        data () {
            return {
                modal: {
                    show: false,
                    load: false,
                    conteudo: {}
                },
                url: urlApi + '/planos/praticos/paginacao',
                tableOptions: { 'thead': ['Constante', 'Título'] },
                search: '',
                table: {
                    currentPage: '',
                    data: '',
                    firstPageUrl: '',
                    from: '',
                    lastPage: '',
                    lastPageUrl: '',
                    nextPageUrl: '',
                    path: '',
                    perPage: '',
                    prevPageUrl: '',
                    to: '',
                    total: '',
                    pages: [],
                    load: true
                }
            }
        },
        mounted () {
            this.loadData()
        },
        methods: {
            salvaInformacoes () {
                let self = this

                self.$http.post(urlApi + '/planos/praticos', Serialize.withFormData('form_plano_pratico')).then((response) => {
                    if (response.status === 200) {
                        AgendamentoController.launchToast('fa-check', response.data.mensagem)
                        self.loadData()
                    } else {
                        AgendamentoController.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
                    }

                }).catch((response) => {
                    AgendamentoController.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
                })
            },
            callbackDataPaginate (response) {
                console.log(response)
                let responseData = response.data
                this.table.currentPage = responseData.current_page
                this.table.data = responseData.data
                this.table.firstPageUrl = responseData.first_page_url
                this.table.from = responseData.from
                this.table.lastPage = responseData.last_page
                this.table.lastPageUrl = responseData.last_page_url
                this.table.nextPageUrl = responseData.next_page_url
                this.table.path = responseData.path
                this.table.perPage = responseData.per_page
                this.table.prevPageUrl = responseData.prev_page_url
                this.table.to = responseData.to
                this.table.total = responseData.total

                this.table.pages = []
                for (let i = 1; i <= (responseData.last_page); i++) {
                    this.table.pages.push(i)
                }
                this.items = this.table.data

                this.table.load = false
            },
            nextPage () {
            this.table.load = true      
            this.$http.get(this.table.nextPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
            },
            previousPage () {
            this.table.load = true
            this.$http.get(this.table.prevPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
            },
            loadData () {
                this.table.load = true
                this.$http.get(this.url).then(this.callbackDataPaginate)
            },
            pagePaginate (page) {
                this.table.load = true
                this.$http.get(this.url + '?page=' + page).then(this.callbackDataPaginate)
            },
        }
    }
</script>

<style scoped>

</style>